var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.901,
    height: 162.394,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.073.281h161.814v161.814H.073z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.274.09h161.611v162.225z",
    fill: "#ff0569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.355 42.426c15.633-15.852 39.312-20.653 59.886-12.141s33.938 28.639 33.801 50.903a55.03 55.03 0 0 1-16.153 39.038z",
    fill: "#0057ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.356 80.773C25.337 66.09 31.142 51.998 41.5 41.59l39.48 39.478-39.185 39.184a55.45 55.45 0 0 1-16.439-39.479z",
    fill: "#242c3d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.9 162.394h0L0 162.101l41.772-41.774a55.86 55.86 0 0 0 8.218 6.64c2.973 1.967 6.128 3.646 9.421 5.012 3.356 1.391 6.839 2.451 10.4 3.167a56.86 56.86 0 0 0 11.165 1.1 56.87 56.87 0 0 0 11.128-1.1A55.98 55.98 0 0 0 102.476 132a55.91 55.91 0 0 0 9.4-4.98 55.86 55.86 0 0 0 8.2-6.6l41.824 41.974h0z",
    fill: "#0057ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.056 161.841V0l41.893 41.892c-2.443 2.521-4.642 5.266-6.57 8.2a55.91 55.91 0 0 0-4.957 9.382 55.98 55.98 0 0 0-3.131 10.35 56.87 56.87 0 0 0 0 22.2 55.98 55.98 0 0 0 3.131 10.35c1.351 3.277 3.011 6.419 4.957 9.382 1.928 2.934 4.127 5.679 6.57 8.2L.056 161.847h0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp03);
export default __webpack_public_path__ + "static/media/scrumlr-lp-03.7de4e93044b7d352e7badc6c300bcb25.svg";
export { ForwardRef as ReactComponent };